import React from 'react';
import { useHistory } from 'react-router-dom';
import { ReactComponent as UserIcon } from '../../assets/icons/user.svg';
import { Button, Menu, MenuItem, Divider } from '@material-ui/core';
import { useConfirm } from 'material-ui-confirm';
import UserSettingsModal from '../Modals/UserSettingsModal/UserSettingsModal';
import { logout, getCurrentUser } from '../../services/AuthService';
import { makeStyles } from '@material-ui/core/styles';
import color from '../../assets/css/colors';
import fontFamily from '../../assets/css/fonts';

const useStyles = makeStyles(() => ({
  badge: {
    padding: '7px 10px',
    borderRadius: 4,
    fontFamily: fontFamily.headers,
    backgroundImage: 'unset',
    backgroundColor: color.primary.opacity,
    borderColor: color.primary.opacity,
    color: color.primary.main,
    border: '1px solid',
    borderImageSource: 'unset',
    '& span': {
      fontSize: 14,
      textTransform: 'capitalize',
    },
    '&:hover': {
      backgroundColor: color.primary.opacity,
      borderColor: color.primary.main,
      opacity: 1,
    },
    '&:active': {
      '& svg path': {
        fill: color.light.main,
      },
    },
  },
  avatar: {
    width: 30,
    height: 30,
    marginRight: 10,
    display: 'inline-block',
    backgroundColor: color.primary.main,
    borderRadius: 4,
    fontSize: 12,
    fontWeight: 700,
    lineHeight: '30px',
    '& svg': {
      marginTop: 4,
      width: 20,
      hieght: 20,
      '& path': {
        fill: color.light.main,
      },
    },
  },
  userInfo: {
    padding: 17,
    fontFamily: fontFamily.label,
    fontSize: 14,
    '& label': {
      display: 'block',
    },
    '& label:first-child': {
      marginBottom: 5,
      fontWeight: 600,
    },
  },
  divider: {
    margin: '10px 0px',
  },
}));

export const UserMenu = () => {
  const activeUser = getCurrentUser();

  const classes = useStyles();
  const history = useHistory();
  const confirm = useConfirm();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [open, setOpen] = React.useState(false);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setOpen(false);
  };

  const handleUserSettings = () => {
    setOpen(true);
  };

  const handleHelpOpen = () => {
    history.push('/app/ticket');
  };

  const handleLogout = () => {
    confirm({
      description: 'You are about to logout from the system.',
      confirmationText: 'Yes, logout',
    }).then(async () => {
      logout();
    });
  };

  return (
    <div>
      <div className="badge-toggle">
        <Button className={classes.badge} onClick={handleClick}>
          <span className={classes.avatar}>
            <UserIcon />
          </span>
          {activeUser?.Name}
        </Button>
      </div>
      <Menu
        keepMounted
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        className="header-menu-popup"
      >
        <div className={classes.userInfo}>
          <label>Email Address:</label>
          <label>{activeUser?.Username}</label>
        </div>
        <Divider className={classes.divider} />
        <MenuItem onClick={handleUserSettings}>Settings</MenuItem>
        <MenuItem onClick={handleHelpOpen}>Help</MenuItem>
        <MenuItem onClick={handleLogout}>Logout</MenuItem>
      </Menu>
      {open && <UserSettingsModal open={open} close={handleClose} />}
    </div>
  );
};
